import React from "react";
import { Button, Row, Col, Layout } from "antd";
import { Link } from "react-router-dom";
import jwtDecode from "jwt-decode";

import { SIZES } from "../../../constants";
import AppContainer from "../../components/AppContainer/AppContainer";
import BackgroundContainer from "../../components/BackgroundContainer/BackgroundContainer";

const { Content } = Layout;
const ManageReportPage = () => {
  const token = jwtDecode(localStorage.getItem("token"));
  const userType = token?.loginAs;

  return (
    <div className="App" style={{ minHeight: "100vh" }}>
      <Layout style={{ minHeight: "100vh" }}>
        <AppContainer title={"MANAGE REPORT"}>
          <Content className="homeContent">
            <BackgroundContainer>
              <Row align="middle" justify="center" className="containAll">
                <Col>
                  <Button
                    style={{
                      borderRadius: SIZES.base,
                      width: 140,
                      height: 140,
                      margin: SIZES.base,
                    }}
                  >
                    <Link to={`/v2/${userType}/overnight-guest`}>
                      Overnight Guest <br /> Report
                    </Link>
                  </Button>
                </Col>

                <Col>
                  <Button
                    style={{
                      borderRadius: SIZES.base,
                      width: 140,
                      height: 140,
                      margin: SIZES.base - 5,
                    }}
                  >
                    <Link to={`/v2/${userType}/daytime-tourist`}>
                      Daytime Tourist <br /> Report
                    </Link>
                  </Button>
                </Col>
                <Col>
                  <Button
                    style={{
                      borderRadius: SIZES.base,
                      width: 140,
                      height: 140,
                      margin: SIZES.base - 5,
                    }}
                  >
                    <Link to={`/v2/${userType}/mice-reports`}>
                      MICE <br /> Report
                    </Link>
                  </Button>
                </Col>
                <Col>
                  <Button
                    style={{
                      borderRadius: SIZES.base,
                      width: 140,
                      height: 140,
                      margin: SIZES.base - 5,
                    }}
                  >
                    <Link to={`/v2/${userType}/inbound-monitoring`}>
                      Inbound
                      <br /> Monitoring
                    </Link>
                  </Button>
                </Col>
                <Col>
                  <Button
                    style={{
                      borderRadius: SIZES.base,
                      width: 140,
                      height: 140,
                      margin: SIZES.base - 5,
                    }}
                  >
                    <Link to={`/v2/${userType}/tour-operator`}>
                      Tour Operator <br /> Report
                    </Link>
                  </Button>
                </Col>
              </Row>
            </BackgroundContainer>
          </Content>
        </AppContainer>
      </Layout>
    </div>
  );
};

export default ManageReportPage;
